import { useEffect, useRef } from "react";

const useDashboardWebSocket = ({
  userId,
  role,
  viewAsAdminId,
  setLivePositions,
  updateDroneTrails,
}) =>{

  const wsRef = useRef(null);
  const bufferRef = useRef([]);
  const reconnectTimeoutRef = useRef(null);

 const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL;

const WS_URL =
  userId && role
    ? `${WS_BASE_URL}/dashboard/?user_id=${userId}&role=${role}${
        viewAsAdminId
          ? `&view_as_admin_id=${viewAsAdminId}`
          : ""
      }`
    : null;
  // ✅ Handle message
  const handleMessage = (event) => {
    try {
      const msg = JSON.parse(event.data);

      let drones = [];

      if (msg.type === "drone_update") {
        drones = Array.isArray(msg.data)
          ? msg.data
          : [msg.data];
      }

      if (msg.type === "single") {
        drones = msg.data || [];
      }

      if (msg.type === "multi") {
        drones = [
          ...(msg.superadmin || []),
          ...(msg.admins || []),
        ];
      }

      if (!drones.length) {
        bufferRef.current = [];
        return;
      }

      const validDrones = drones.filter(
        (d) =>
          d &&
          d.lat != null &&
          d.lng != null
      );

      bufferRef.current = validDrones;

    } catch (e) {
      console.error("❌ WS parse error:", e);
    }
  };

  // ✅ Connect WS
  const connectWS = () => {

    // IMPORTANT
    if (!WS_URL) {
      console.log("❌ WS URL missing");
      return;
    }

    console.log("🔥 Connecting WebSocket:", WS_URL);

    const ws = new WebSocket(WS_URL);

    wsRef.current = ws;

    ws.onopen = () => {
      console.log("✅ WS connected");
    };

    ws.onmessage = handleMessage;

    ws.onerror = (err) => {
      console.error("❌ WS error:", err);
    };

    ws.onclose = () => {
      console.log("❌ WS closed");

      wsRef.current = null;

      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }

      reconnectTimeoutRef.current = setTimeout(() => {
        console.log("🔁 Reconnecting WS...");
        connectWS();
      }, 3000);
    };
  };

  // ✅ WS Effect
  useEffect(() => {
  if (!WS_URL) {
    console.log("⛔ Waiting for user session...");
    return;
  }

  connectWS();

  return () => {
    if (wsRef.current) wsRef.current.close();
    if (reconnectTimeoutRef.current)
      clearTimeout(reconnectTimeoutRef.current);
  };
}, [WS_URL]);   // 👈 IMPORTANT CHANGE
  // ✅ Drone update effect
  useEffect(() => {

    const interval = setInterval(() => {

      if (bufferRef.current.length === 0) {
        setLivePositions([]);
        return;
      }

      const freshDrones = bufferRef.current.filter(
        (d) =>
          d.ts &&
          Date.now() - d.ts < 10000
      );

      setLivePositions(freshDrones);

      if (updateDroneTrails) {
        updateDroneTrails(freshDrones);
      }

    }, 2500);

    return () => clearInterval(interval);

  }, [setLivePositions, updateDroneTrails]);

  return null;
};

export default useDashboardWebSocket;